import { RESPONSE_CODES } from './responseCodes';

const RESPONSE_CODE_VALUES = Object.values(RESPONSE_CODES);

export {
  RESPONSE_CODE_VALUES
};
